// extracted by mini-css-extract-plugin
export default {"outletWrapper":"RootLayout_outletWrapper__YmqMU","outletOffset":"RootLayout_outletOffset__-6qh5"};